const roundWeight = weight => Math.round(weight * 100) / 100;

export const formatWeight = weight =>
  weight == null ? "No weight" : `${roundWeight(weight)}kg`;

const isActiveWarehouseItem = warehouseItem =>
  Boolean(warehouseItem) && !warehouseItem.destroyed;

const toBreakdownRow = warehouseItem => ({
  id: warehouseItem.id,
  category: warehouseItem.category?.description || "Uncategorised",
  description: warehouseItem.itemDescription || warehouseItem.description || "",
  isPacking: Boolean(warehouseItem.category?.weightPacked),
  weight: warehouseItem.weight ?? null,
});

const sumWeights = rows =>
  roundWeight(rows.reduce((total, row) => total + (row.weight || 0), 0));

export const getPackedWeightBreakdown = warehouseItems => {
  const rows = (warehouseItems || [])
    .filter(isActiveWarehouseItem)
    .map(toBreakdownRow);

  return {
    rows,
    packedWeight: sumWeights(rows),
    packingWeight: sumWeights(rows.filter(row => row.isPacking)),
    weight: sumWeights(rows.filter(row => !row.isPacking)),
  };
};
